import React, { useState, useEffect, Fragment } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Col } from "react-bootstrap";
import UserSidebar from "../../Component/UserSidebar";
import { UCWords } from "../../utils/helpers";
import Slider from "react-slick";
import ReportUser from "../Forum/reportUser";
import ScheduleMeetingModal from "../MentorDashboard1/scheduleMeetingModal";
import queryString from "query-string";
import { fetchMyWaitList } from "./Slice/myWaitListSlice";
import PropTypes from "prop-types";

function SidebarAddClass(e) {
  e.preventDefault();
  document.getElementById("OnscrollBody").classList.toggle("show_sidebar");
}

function formatText(text) {
  return text.split('\r\n').map((line, index) => (
    <React.Fragment key={line}>
      {line}
      <br />
    </React.Fragment>
  ));
}

const Index = (props) => {

  const dispatch = useDispatch();

  const { data: myWaitListData, pagination } = useSelector((state) => state?.myWaitList);
  const userInfo = useSelector((state) => state?.userInfo);
  const { title } = props;
  const [room] = useState({ roomname: "" });

  const Mentors_details = {
    dots: true,
    arrows: false,
    infinite: false,
    speed: 500,
    unslick: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          unslick: false,
        },
      },
    ],
  };

  const location = useLocation();
  const history = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const queryStringParsed = queryString.parse(location.search);
    const request = {};
    if (params.get("sort")) {
      const sort = queryStringParsed["sort"];
      const direction = queryStringParsed["direction"];
      request.sort = sort;
      request.direction = direction;
    }
    if (params.get("page")) {
      const page = queryStringParsed["page"];
      request.page = page;
    }
    if (params.get("keyword")) {
      const keyword = queryStringParsed["keyword"];
      request.keyword = keyword;
    }
    document.title = title;
    dispatch(fetchMyWaitList({ request, userId: userInfo.id }));
  }, [title, dispatch, location, userInfo]);

  const downloadResume = (e, url) => {
    e.preventDefault();
    window.open(url, "_blank");
  };

  useEffect(() => {
    if (room.roomname) {
      history("/chat?roomKey=" + room.roomname);
    }
  }, [room, history]);

  const [userData2] = useState({});
  const [reportModalShow, setReportModalShow] = useState(false);
  const [scheduleModal, setScheduleModal] = useState(false);
  const [scheduleUser] = useState({})

  return (
    <div>
      <div className="dashboard_outer">
        <UserSidebar />
        <div className="dashboard_inner">
          <div className="d-block mb-3 mb-md-0 mb-md-none toggle_btn_outer">
            <Link
              to=""
              onClick={SidebarAddClass}
              className="toggle_btn d-lg-none"
            >
              <i className="fas fa-bars"></i>
            </Link>
          </div>
          <h1 className="dash_heading">My Waitlist</h1>
          <div className="box_wrap shadow-sm bg-white mentor_box">
            <Slider {...Mentors_details}>
              {myWaitListData?.map((item, key) => (
                <Fragment key={item.id}>
                  <div className="mentro_details mb-2 mb-md-4 d-flex  flex-wrap">
                    <div className="mentro_details_leftbar">
                      <div className="mentor_pic">
                        <img
                          src={item.mentors_image}
                          alt="find a career mentor online"
                        />
                      </div>
                      <div className="profile_btn mt-3 ">
                        <a
                          href={item.mentor_linkedin}
                          className="link_btn btn_red btn m-0"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src={"/assets/images/linkedin.png"}
                            className="me-2 bg-white"
                            alt="career mentoring services"
                          />{" "}
                          Linkedin Profile
                        </a>
                      </div>
                      {/* } */}
                    </div>
                    <div className="mentro_details_sidebar">
                      <div className="d-flex ">
                        <div className="name_info">
                          <h4 className="mb-3">{item.mentor_name}</h4>
                          {item.mentors_organization && (
                            <>
                              <h3 className="mb-1">Organization</h3>
                              <div className="">
                                <p>
                                  {item.mentors_organization}
                                </p>
                              </div>
                            </>
                          )}
                          {item.mentors_position && (
                            <>
                              <h3 className="mb-1">Position</h3>
                              <div className="">
                                <p>
                                  {item.mentors_position}
                                </p>
                              </div>
                            </>
                          )}
                          {item.mentor_main_area && (
                            <>
                              <h3 className="mb-1">Domains</h3>
                              <div className="">
                                <p>
                                  {UCWords(item.mentor_main_area)}
                                </p>
                              </div>
                            </>
                          )}
                          {item.mentor_about && (
                            <>
                              <h3 className="mb-1">About me</h3>
                              <div className="">
                                <p>
                                  {formatText(item.mentor_about)}
                                </p>
                              </div>
                            </>
                          )}
                          {item?.restrictions_boundaries && <>
                            <h3 className="mb-1">Restrictions Boundaries</h3>
                            <div className="">
                              <p>
                                {formatText(item?.restrictions_boundaries)}
                              </p>
                            </div>
                          </>
                          }
                          {item?.communication_tools && <>
                            <h3 className="mb-1">Communication Tools Preference</h3>
                            <div className="">
                              <p>
                                {formatText(item?.communication_tools)}
                              </p>
                            </div>
                          </>
                          }
                          {item?.frequency_communication && <>
                            <h3 className="mb-1">Preferred Frequency Communication</h3>
                            <div className="">
                              <p>
                                {formatText(item?.frequency_communication)}
                              </p>
                            </div>
                          </>
                          }
                          {item?.any_particular_program && <>
                            <h3 className="mb-1">Any Particular Program</h3>
                            <div className="">
                              <p>
                                {item?.any_particular_program_data}
                              </p>
                            </div>
                          </>}
                          {item?.topics && <>
                            <h3 className="mb-1">Topics</h3>
                            <div className="">
                              <p>
                                {item?.topics}
                              </p>
                            </div>
                          </>}
                          {Array.isArray(item?.mentor_past_board_roles) &&
                            item.mentor_past_board_roles.length > 0 && (
                              <div className="mentro_text">
                                <h3 className="mb-1">Mentor's Past Board Roles</h3>

                                {item.mentor_past_board_roles.map((role) => (
                                  <div
                                    key={role.id}
                                    className="mb-2 p-2 border-start ps-3"
                                    style={{ borderLeftColor: "#007bff", borderLeftWidth: "3px" }}
                                  >
                                    <p className="mb-1">
                                      <strong>{role.rep_company_name}</strong>
                                    </p>
                                    <p className="mb-1">
                                      <em>{role.rep_board_title}</em>
                                    </p>
                                    <p className="mb-0 text-muted" style={{ fontSize: "12px" }}>
                                      {new Date(role.rep_start_date).toLocaleDateString()} –{" "}
                                      {new Date(role.rep_end_date).toLocaleDateString()}
                                    </p>
                                  </div>
                                ))}
                              </div>
                            )}

                          {Array.isArray(item?.mentee_past_board_roles) &&
                            item.mentee_past_board_roles.length > 0 && (
                              <div className="mentro_text">
                                <h3 className="mb-1">Mentee's Past Board Roles</h3>

                                {item.mentee_past_board_roles.map((role) => (
                                  <div
                                    key={role.id}
                                    className="mb-2 p-2 border-start ps-3"
                                    style={{ borderLeftColor: '#007bff', borderLeftWidth: '3px' }}
                                  >
                                    <p className="mb-1">
                                      <strong>{role.rep_company_name}</strong>
                                    </p>
                                    <p className="mb-1">
                                      <em>{role.rep_board_title}</em>
                                    </p>
                                    <p className="mb-0 text-muted" style={{ fontSize: '12px' }}>
                                      {new Date(role.rep_start_date).toLocaleDateString()} -{" "}
                                      {new Date(role.rep_end_date).toLocaleDateString()}
                                    </p>
                                  </div>
                                ))}
                              </div>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                  {item.status === 4 &&
                    item.is_completed !== 1 &&
                    item.mentee_termination_status === 2 && (
                      <div
                        className="mentro_details mb-2 mb-md-4 d-flex  flex-wrap"
                        key={item.id}
                      >
                        <div className="mentro_details_leftbar">
                          <div className="mentor_pic">
                            <img
                              src={item.mentors_image}
                              alt="career mentoring for women"
                            />
                          </div>
                          <div className="profile_btn mt-3">
                            <a
                              href={item.mentor_linkedin}
                              className="link_btn btn m-0"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img
                                src={"/assets/images/linkedin.png"}
                                className="me-2 bg-white"
                                alt="carrer mentoring for women"
                              />{" "}
                              Linkedin Profile
                            </a>
                          </div>
                          {/* } */}
                        </div>
                        <div className="mentro_details_sidebar">
                          <div className="row py-2 py-md-4">
                            <Col xl={4}>
                              <div className="d-flex ">
                                <div className="name_info">
                                  <h4 className="mb-0">{item.mentor_name}</h4>
                                  <h5>
                                    <span className="d-block">
                                      {item.mentors_organization}
                                    </span>
                                  </h5>
                                  <h5>{item.mentors_position}</h5>
                                  <h5>{UCWords(item.mentor_main_area)}</h5>
                                </div>
                              </div>
                            </Col>
                          </div>
                          <ul className="date_list py-2 py-md-4">
                            <li className="d-sm-flex align-items-center">
                              <div className="date_icon">
                                <img
                                  src="/assets/images/pdf.png"
                                  alt="download-icon"
                                />
                              </div>

                              <div className="date_content ps-2">
                                <Link
                                  to=""
                                  download
                                  className="d-block date color_red"
                                  onClick={(e) =>
                                    downloadResume(e, item.mentee_resume)
                                  }
                                >
                                  {"Download Resume"}
                                </Link>
                              </div>
                            </li>

                            {/* <li className="d-flex align-items-center">
                              &nbsp;
                            </li> */}
                          </ul>
                          <h3 className="mb-1">About me</h3>
                          <div className="about-text">
                            <p>{formatText(item.mentors_about)}</p>
                          </div>
                          {item?.restrictions_boundaries && <>
                            <h3 className="mb-1">Restrictions Boundaries</h3>
                            <div className="">
                              <p>
                                {formatText(item?.restrictions_boundaries)}
                              </p>
                            </div>
                          </>
                          }
                          {item?.communication_tools && <>
                            <h3 className="mb-1">Communication Tools Preference</h3>
                            <div className="">
                              <p>
                                {formatText(item?.communication_tools)}
                              </p>
                            </div>
                          </>
                          }

                          {item?.frequency_communication && <>
                            <h3 className="mb-1">Preferred Frequency Communication</h3>
                            <div className="">
                              <p>
                                {formatText(item?.frequency_communication)}
                              </p>
                            </div>
                          </>
                          }
                          {item?.any_particular_program && <>
                            <h3 className="mb-1">Any Particular Program</h3>
                            <div className="">
                              <p>
                                {item?.any_particular_program_data}
                              </p>
                            </div>
                          </>}
                          {item?.topics && <>
                            <h3 className="mb-1">Topics</h3>
                            <div className="">
                              <p>
                                {item?.topics}
                              </p>
                            </div>
                          </>}
                          {item?.mentor_past_board_roles && item?.mentor_past_board_roles.length > 0 && (
                            <div className="mentro_text">
                              <h3 className="mb-1">Mentor's Past Board Roles</h3>
                              {item.mentor_past_board_roles.map((role) => (
                                <div key={role.id} className="mb-2 p-2 border-start ps-3" style={{ borderLeftColor: '#007bff', borderLeftWidth: '3px' }}>
                                  <p className="mb-1"><strong>{role.rep_company_name}</strong></p>
                                  <p className="mb-1"><em>{role.rep_board_title}</em></p>
                                  <p className="mb-0 text-muted" style={{ fontSize: '12px' }}>
                                    {new Date(role.rep_start_date).toLocaleDateString()} - {new Date(role.rep_end_date).toLocaleDateString()}
                                  </p>
                                </div>
                              ))}
                            </div>
                          )}
                          {item?.mentee_past_board_roles && item?.mentee_past_board_roles.length > 0 && (
                            <div className="mentro_text">
                              <h3 className="mb-1">Mentee's Past Board Roles</h3>
                              {item.mentee_past_board_roles.map((role) => (
                                <div key={role.id} className="mb-2 p-2 border-start ps-3" style={{ borderLeftColor: '#007bff', borderLeftWidth: '3px' }}>
                                  <p className="mb-1"><strong>{role.rep_company_name}</strong></p>
                                  <p className="mb-1"><em>{role.rep_board_title}</em></p>
                                  <p className="mb-0 text-muted" style={{ fontSize: '12px' }}>
                                    {new Date(role.rep_start_date).toLocaleDateString()} - {new Date(role.rep_end_date).toLocaleDateString()}
                                  </p>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                </Fragment>
              ))}
            </Slider>
            {(myWaitListData?.length === 0 || pagination?.total == 0) && (
              <div className="text-center">No waitlist found.</div>
            )}
          </div>
        </div>
      </div>

      {reportModalShow && (
        <ReportUser
          show={reportModalShow}
          userdata={userData2}
          onHide={() => setReportModalShow(false)}
          centered
          size="xl"
          className="mentor_modal"
        />
      )}
      {scheduleModal && (
        <ScheduleMeetingModal
          show={scheduleModal}
          scheduleUser={scheduleUser}
          onHide={() => setScheduleModal(false)}
          centered
          size="xl"
          className="mentor_modal"
        />
      )}
    </div>
  );
};

Index.propTypes = {
  title: PropTypes.string.isRequired,
};

export default Index;
